import { Grid, Paper, Tabs, Tab, Box } from "@mui/material";
// import AssignmentIcon from "@mui/icons-material/Assignment";
import ErrorIcon from "@mui/icons-material/Error";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import { useEffect, useState, useCallback } from "react";
import DatagridCustom from "../components/General/DatagridCustom";
import { useToast } from "../context/ToastContext";
import { getJobHistories } from "../services/JobHistoryService"; // Servicio para llamar al backend

export default function JobStatusView() {
  const { showToast } = useToast();
  const [tabValue, setTabValue] = useState(0);
  const [data, setData] = useState({
    jobs_pending: { data: [], total: 0 },
    jobs_failed: { data: [], total: 0 },
    job_history: { data: [], total: 0 },
  });
  const [paginationModels, setPaginationModels] = useState({
    pending: { page: 0, pageSize: 10 },
    failed: { page: 0, pageSize: 10 },
    history: { page: 0, pageSize: 10 },
  });
  const [filterModels, setFilterModels] = useState({
    pending: { items: [], quickFilterValues: [] },
    failed: { items: [], quickFilterValues: [] },
    history: { items: [], quickFilterValues: [] },
  });
  const [loading, setLoading] = useState(false);

  const fetchJobs = useCallback(async () => {
    setLoading(true);
    try {
      const activeKey =
        tabValue === 0 ? "pending" : tabValue === 1 ? "failed" : "history";

      const { page, pageSize } = paginationModels[activeKey];
      const searchTerm =
        filterModels[activeKey].quickFilterValues?.join(" ") || "";

      const res = await getJobHistories({
        page: page + 1,
        perPage: pageSize,
        search: searchTerm,
      });

      setData(res.data);
    } catch (error) {
      showToast("No se pudieron cargar los datos de los procesos.", "error")
    } finally {
      setLoading(false);
    }
  }, [paginationModels, filterModels, tabValue, showToast]);

  useEffect(() => {
    fetchJobs();
  }, [paginationModels, filterModels, tabValue, fetchJobs]);

  const handleFilterModelChange = (type, newFilterModel) => {
    setFilterModels((prev) => ({
      ...prev,
      [type]: newFilterModel,
    }));
    setPaginationModels((prev) => ({
      ...prev,
      [type]: { ...prev[type], page: 0 },
    }));
  };

  const columnsPending = [
    { field: "job_label", headerName: "Proceso", flex: 1.6 },
    { field: "lawyer_name", headerName: "Abogado", flex: 1.6 },
    { field: "files_count", headerName: "Expedientes", flex: 0.8 },
    {
      field: "files_sample",
      headerName: "Ejemplos",
      flex: 1.6,
      valueGetter: (v) => (Array.isArray(v) ? v.join(", ") : ""),
    },
    { field: "queue", headerName: "Cola", flex: 0.8 },
    { field: "attempts", headerName: "Intentos", flex: 0.6 },
    // {
    //   field: "created_at",
    //   headerName: "Creado",
    //   flex: 1.2,
    //   valueGetter: (params) => {
    //     const date = new Date(params);
    //     if (isNaN(date.getTime())) return "Fecha inválida";
    //     const d = String(date.getDate()).padStart(2, "0");
    //     const m = String(date.getMonth() + 1).padStart(2, "0");
    //     const y = date.getFullYear();
    //     const hh = String(date.getHours()).padStart(2, "0");
    //     const mm = String(date.getMinutes()).padStart(2, "0");
    //     return `${d}/${m}/${y} ${hh}:${mm}`;
    //   },
    // },
  ];

  const columnsFailed = [
    { field: "job_label", headerName: "Proceso", flex: 1.6 },
    { field: "lawyer_name", headerName: "Abogado", flex: 1.6 },
    { field: "files_count", headerName: "Expedientes", flex: 0.8 },
    {
      field: "error_message",
      headerName: "Motivo",
      flex: 2.2,
    },
    {
      field: "failed_at",
      headerName: "Falló en",
      flex: 1.2,
      valueGetter: (params) => {
        const date = new Date(params);
        if (isNaN(date.getTime())) return "Fecha inválida";
        const d = String(date.getDate()).padStart(2, "0");
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const y = date.getFullYear();
        const hh = String(date.getHours()).padStart(2, "0");
        const mm = String(date.getMinutes()).padStart(2, "0");
        return `${d}/${m}/${y} ${hh}:${mm}`;
      },
    },
  ];

  // const columnsHistory = [
  //   { field: "job_name", headerName: "Nombre", flex: 2 },
  //   // { field: "status", headerName: "Estado", flex: 1 },
  //   {
  //     field: "started_at",
  //     headerName: "Inicio",
  //     flex: 1.5,
  //     valueGetter: (params) => {
  //       const date = new Date(params);

  //       if (isNaN(date.getTime())) {
  //         return "Fecha inválida";
  //       }

  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0");
  //       const year = date.getFullYear();
  //       const hours = String(date.getHours()).padStart(2, "0");
  //       const minutes = String(date.getMinutes()).padStart(2, "0");

  //       return `${day}/${month}/${year} ${hours}:${minutes}`;
  //     },
  //   },
  //   {
  //     field: "finished_at",
  //     headerName: "Fin",
  //     flex: 1.5,
  //     valueGetter: (params) => {
  //       const date = new Date(params);

  //       if (isNaN(date.getTime())) {
  //         return "Fecha inválida";
  //       }

  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0");
  //       const year = date.getFullYear();
  //       const hours = String(date.getHours()).padStart(2, "0");
  //       const minutes = String(date.getMinutes()).padStart(2, "0");

  //       return `${day}/${month}/${year} ${hours}:${minutes}`;
  //     },
  //   },
  // ];

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

        <Paper
          elevation={3}
          sx={{
            p: 3,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow: "none",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={(e, val) => setTabValue(val)}
            aria-label="Procesos estado"
            sx={{ mb: 2 }}
          >
            <Tab icon={<HourglassTopIcon />} label="Pendientes" />
            <Tab icon={<ErrorIcon />} label="Fallidos" />
            {/* <Tab icon={<AssignmentIcon />} label="Historial" /> */}
          </Tabs>
        </Paper>

        {tabValue === 0 && (
          <Box
            sx={{
              "& .MuiPaper-root": {
                boxShadow: "none",
                borderRadius: 0,
              },
            }}
          >
            <DatagridCustom
              rows={data.jobs_pending.data}
              columns={columnsPending}
              title="Procesos Pendientes"
              description="Procesos en cola"
              paginationModel={paginationModels.pending}
              onPaginationChange={(model) =>
                setPaginationModels((prev) => ({
                  ...prev,
                  pending: model,
                }))
              }
              total={data.jobs_pending.total}
              loading={loading}
              filterModel={filterModels.pending}
              onFilterChange={(model) =>
                handleFilterModelChange("pending", model)
              }
              // icon={<AssignmentIcon/>}
              filterMode="server"
              isServerPagination
            />
          </Box>
        )}

        {tabValue === 1 && (
          <Box
            sx={{
              "& .MuiPaper-root": {
                boxShadow: "none",
                borderRadius: 0,
              },
            }}
          >
            <DatagridCustom
              rows={data.jobs_failed.data}
              columns={columnsFailed}
              title="Procesos Fallidos"
              description="Procesos con errores"
              paginationModel={paginationModels.failed}
              onPaginationChange={(model) =>
                setPaginationModels((prev) => ({
                  ...prev,
                  failed: model,
                }))
              }
              total={data.jobs_failed.total}
              loading={loading}
              filterModel={filterModels.failed}
              onFilterChange={(model) =>
                handleFilterModelChange("failed", model)
              }
              filterMode="server"
              isServerPagination
            />
          </Box>
        )}

        {/* {tabValue === 2 && (
          <Box
            sx={{
              "& .MuiPaper-root": {
                boxShadow: "none",
                borderRadius: 0,
              },
            }}
          >
            <DatagridCustom
              rows={data.job_history.data}
              columns={columnsHistory}
              title="Historial de Procesos"
              description="Historial de ejecución"
              paginationModel={paginationModels.history}
              onPaginationChange={(model) =>
                setPaginationModels((prev) => ({
                  ...prev,
                  history: model,
                }))
              }
              total={data.job_history.total}
              loading={loading}
              filterModel={filterModels.history}
              onFilterChange={(model) =>
                handleFilterModelChange("history", model)
              }
              isServerPagination
            />
          </Box>
        )} */}
      </Grid>
    </Grid>
  );
}
